/**
 * 通知域枚举常量
 * 根据 notification/frontend-spec.md 规范定义
 */

// 通知类型
export enum NotificationType {
  CREATE_ORDER = 'CREATE_ORDER',       // 创建订单
  CANCEL_ORDER = 'CANCEL_ORDER',       // 取消订单
  RETURN_ORDER = 'RETURN_ORDER',       // 退货订单
  APPROVAL = 'APPROVAL',               // 审批
}

// 通知类型选项
export const NOTIFICATION_TYPE_OPTIONS = [
  { value: NotificationType.CREATE_ORDER, label: 'notification.enums.type.createOrder', color: 'blue' },
  { value: NotificationType.CANCEL_ORDER, label: 'notification.enums.type.cancelOrder', color: 'red' },
  { value: NotificationType.RETURN_ORDER, label: 'notification.enums.type.returnOrder', color: 'orange' },
  { value: NotificationType.APPROVAL, label: 'notification.enums.type.approvals', color: 'purple' },
];

// 通知状态
export enum NotificationStatus {
  PENDING = 'PENDING',               // 待发送
  SENT = 'SENT',                     // 已发送
  DELIVERED = 'DELIVERED',           // 已送达
  FAILED = 'FAILED',                 // 发送失败
  READ = 'READ'                      // 已读
}

// 通知状态选项
export const NOTIFICATION_STATUS_OPTIONS = [
  { value: NotificationStatus.PENDING, label: 'notification.enums.status.pending', color: 'default' },
  { value: NotificationStatus.SENT, label: 'notification.enums.status.sent', color: 'processing' },
  { value: NotificationStatus.DELIVERED, label: 'notification.enums.status.delivered', color: 'success' },
  { value: NotificationStatus.FAILED, label: 'notification.enums.status.failed', color: 'error' },
  { value: NotificationStatus.READ, label: 'notification.enums.status.read', color: 'success' },
];

// 通知渠道
export enum NotificationChannel {
  PUSH = 'PUSH',                     // APP推送
  SMS = 'SMS',                       // 短信
  EMAIL = 'EMAIL',                   // 邮件
  IN_APP = 'IN_APP',                 // 站内信
  WEBHOOK = 'WEBHOOK'                // Webhook回调
}

// 通知渠道选项
export const NOTIFICATION_CHANNEL_OPTIONS = [
  { value: NotificationChannel.PUSH, label: 'notification.enums.channel.push', color: 'blue' },
  { value: NotificationChannel.SMS, label: 'notification.enums.channel.sms', color: 'cyan' },
  { value: NotificationChannel.EMAIL, label: 'notification.enums.channel.email', color: 'green' },
  { value: NotificationChannel.IN_APP, label: 'notification.enums.channel.inApp', color: 'purple' },
  { value: NotificationChannel.WEBHOOK, label: 'notification.enums.channel.webhook', color: 'orange' },
];

// 通知优先级
export enum NotificationPriority {
  HIGH = 'HIGH',
  NORMAL = 'NORMAL',
  LOW = 'LOW'
}

// 通知优先级选项
export const NOTIFICATION_PRIORITY_OPTIONS = [
  { value: NotificationPriority.HIGH, label: 'notification.enums.priority.high', color: 'red' },
  { value: NotificationPriority.NORMAL, label: 'notification.enums.priority.normal', color: 'blue' },
  { value: NotificationPriority.LOW, label: 'notification.enums.priority.low', color: 'default' },
];
